<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">

        <el-carousel :interval="3000" :height="bannerHeight + 'px'" direction="vertical" :autoplay="true">
          <el-carousel-item>
            <img src="~@/common/imgs/performance1.jpg" alt="">
          </el-carousel-item>
          <el-carousel-item>
            <img src="~@/common/imgs/performance2.jpg" alt="">
          </el-carousel-item>
          <el-carousel-item>
            <img src="~@/common/imgs/performance3.jpg" alt="">
          </el-carousel-item>
        </el-carousel>
    </div>

    <!-- content -->
    <div class="news-content">
      <div class="news-left">
        <dl>
          <dt>
            <h3>业绩展示</h3>
            <p>Performance Show</p>
          </dt>
          <dd class="w25">
            <router-link :to="{path:'/ShowGrades',query:{id: '5'}}" :class="this.$route.query.id == '5' ? 'active' : ''"><span>医疗建筑</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link :to="{path:'/ShowGrades',query:{id: '6'}}" :class="this.$route.query.id == '6' ? 'active' : ''"><span>幕墙、门窗</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link :to="{path:'/ShowGrades',query:{id: '7'}}" :class="this.$route.query.id == '7' ? 'active' : ''"><span>商业空间</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link :to="{path:'/ShowGrades',query:{id: '8'}}" :class="this.$route.query.id == '8' ? 'active' : ''"><span>文化建筑</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link :to="{path:'/ShowGrades',query:{id: '9'}}" :class="this.$route.query.id == '9' ? 'active' : ''"><span>办公行政空间</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link :to="{path:'/ShowGrades',query:{id: '10'}}" :class="this.$route.query.id == '10' ? 'active' : ''"><span>交通场站</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link :to="{path:'/ShowGrades',query:{id: '11'}}" :class="this.$route.query.id == '11' ? 'active' : ''"><span>酒店及会所</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link :to="{path:'/ShowGrades',query:{id: '12'}}" :class="this.$route.query.id == '12' ? 'active' : ''"><span>住宅精装修</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w33">
            <router-link :to="{path:'/ShowGrades',query:{id: '13'}}" :class="this.$route.query.id == '13' ? 'active' : ''"><span>金融场所</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w33">
            <router-link :to="{path:'/ShowGrades',query:{id: '14'}}" :class="this.$route.query.id == '14' ? 'active' : ''"><span>机电安装工程</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w33">
            <router-link :to="{path:'/ShowGrades',query:{id: '15'}}" :class="this.$route.query.id == '15' ? 'active' : ''"><span>电子及智能化工程</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
        </dl>
      </div>

      <div class="news-right">
        <div class="news-bread">
          <h2>业绩展示</h2>/<i>{{pageName}}</i>
        </div>
        <div class="architecture">
          <h3>{{title}}</h3>
          <span v-html="turn(remark)" class="import"></span>
          <p v-html="turn(descripe)"></p>
          <el-carousel :interval="4000" type="card" height="320px">
            <el-carousel-item v-for="item in photoList" :key="item.id">
              <img :src="item.fileVo.url" alt="">
            </el-carousel-item>
          </el-carousel>
          <ul class="pj-namelist">
            <li v-for="item in nameList" :key="item.id">
              <el-link type="primary" @click="showData(item.id)" :title="item.title" :underline="false"><i class="el-icon-connection"></i> {{item.title}}</el-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- footer -->
    <foot-link></foot-link>
     <!-- 回到顶部 -->
    <el-backtop></el-backtop>
    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import axios from 'axios'
  import global_msg from '@/common/js/global.js'

  export default {
    name: 'ShowGrades',
    data() {
      return {
        bannerHeight: 318, //图片父容器高度
        url: global_msg.baseUrl,
        page: this.$route.query.id,
        pageName: '',
        isActive: false,
        photoList: [],
        nameList: [],
        title: '',
        descripe: '',
        remark: '',
        nwiId: 0
      }
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    },
    created() {
      this.loadPage();
    },
    mounted() {
      this.setSize();
      // 窗口大小发生改变时,调用一次
      window.onresize = () => {
        this.setSize();
      }
    },
    watch: {
      '$route': 'loadPage'
    },
    methods: {
      // 格式化
      turn(data) {
        return data
      },
      loadPage() {
        const id = this.$route.query.id
        switch (id) {
          case '5':
            this.pageName = '医疗建筑';
            break;
          case '6':
            this.pageName = '幕墙、门窗';
            break;
          case '7':
            this.pageName = '商业空间';
            break;
          case '8':
            this.pageName = '文化建筑';
            break;
          case '9':
            this.pageName = '办公行政空间';
            break;
          case '10':
            this.pageName = '交通场站';
            break;
          case '11':
            this.pageName = '酒店及会所';
            break;
          case '12':
            this.pageName = '住宅精装修';
            break;
          case '13':
            this.pageName = '金融场所';
            break;
          case '14':
            this.pageName = '机电安装工程';
            break;
          case '15':
            this.pageName = '电子及智能化工程';
        }
        let pageName = this.pageName
        axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=' + pageName).then((response) => {
          this.nameList = response.data.subject.result;
          if (this.nameList.length > 0) {
            this.nwiId = response.data.subject.result[0].id
            this.showData(this.nwiId);
          } else {
            this.photoList = [];
            this.title = '';
            this.descripe = ''
          }
        });
      },
      showData(id) {
        //请求图片列表
        axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findById?id=' + id).then((response) => {
          this.photoList = response.data.subject.attachmentVos;
          this.title = response.data.subject.title;
          this.descripe = response.data.subject.generalDesc;
          this.remark = response.data.subject.importantDesc
        });
      },
      setSize: function() {
        // 首次加载时,需要调用一次
        this.screenWidth = window.innerWidth;
        // 通过浏览器宽度(图片宽度)计算高度
        this.bannerHeight = 320 / 1920 * this.screenWidth;
      }
    }
  }
</script>

<style scoped>
  @media screen and (max-width: 1120px){
    #footer {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ShowGrades.vue